class BranchesDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.subtableTemplate = null;
        this.subtableHeaderTemplate = null;
        this.datatable = this.init('#branch-datatable', organizationID);

        this.initActions(organizationID);
        $(document).on('click', '.create-new-branch-button', function(e) {
            new BranchForm();
        });
    }
    init(el, organizationID){
        const thisClass = this;
        // Get subtable template
        let subtable = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_template"]');
        let subtableHeader = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_header_template"]');
        this.subtableTemplate = subtable.cloneNode(true);
        this.subtableHeaderTemplate = subtableHeader.cloneNode(true);
        this.subtableTemplate.classList.remove('d-none');
        this.subtableHeaderTemplate.classList.remove('d-none');
        // Remove subtable template
        subtable.parentNode.removeChild(subtable);

        const datatable =  $(el).DataTable({
            processing: true,
            serverSide: false,
            stateSave: false,
            info: true,
            paging: true,
            order: [[1, 'asc']],
            ajax: {
                url: '/branches/?do=getBranches',
                type: 'POST',
                data: {
                    organizationId: organizationID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=systems-datatable_length]').select2({minimumResultsForSearch: -1});
                // Add delay to datatable search
            },
            columns: [
                {
                    sortable: false,
                    data: 'branchSubnetUuid',
                    render: function (data, type, row) {
                        return '<button type="button" class="btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-20px w-20px ' +
                            (row['branch_segments'].length === 0 ? 'd-none' : '')+'" data-kt-docs-datatable-subtable="expand_row">\n' +
                            '<i class="ki-duotone ki-plus fs-3 m-0 toggle-off"></i><i class="ki-duotone ki-minus fs-3 m-0 toggle-on"></i></button>';
                    }
                },
                {
                    data: 'id',
                    title: 'Name',
                    sortable: true,
                    render: function (data, type, row) {
                        let iconUrl = '/media/goodaccess/icons/branch/'+row['icon_id']+'.svg';
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white">' +
                            '               <img src="'+iconUrl+'" alt="icon">' +
                            '           </div>' +
                            (!row['is_connected'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Not Connected</div>">&#10005;</span>' : '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Connected</div>">\t\n' + '&#10003;</span>') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div data-cy="cb-id" id="'+row['id']+'"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['allowed_to_edit'] ? 'edit-branch' : '') +'" data-branch-name="'+row['name']+'">'+row['name']+'</span></div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['subnet']+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'id',
                    title: 'Gateway',
                    className: 'min-w-150px',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden">' +
                            '               <img src="/media/goodaccess/country-flags/png100px/' + row['gateway']['iso2'] + '.png" class="h-40px mw-unset" alt="flag">' +
                            '           </div>' +
                            (row['gateway']['status'] === 'down' ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Gateway status: <b>DOWN<b></div>">!</span>' : '')+
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column" id="' + row['uuid'] + '">' +
                            '           <div '+(row['allowed_to_edit'] ? 'id="'+row['gateway']['id']+'"' : '')+'><span class="fw-bold text-primary primary text-decoration-underline-ga fs-6'+(row['allowed_to_edit'] ? ' edit-gateway' : '')+'">'+row['gateway']['name']+'</span></div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['gateway']['subnet']+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'protocol',
                    title: 'Protocol',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<div class="d-flex flex-stack">' +
                                '   <span class="fw-bold d-block fs-7 text-center text-primary primary">'+row['protocol']+'</span>' +
                                '</div>';
                    }
                },
                {
                    data: 'is_connected',
                    title: 'Status',
                    sortable: true,
                    render: function (data, type, row) {
                        var message = '';
                        if(row['is_connected']){
                            message = '<a href="#" class="fw-bold text-success connection_status">Connected</a>';
                        }else{
                            message = '<a href="#" class="fw-bold text-danger connection_status">Not Connected</a>';
                        }
                        return '<div class="d-flex flex-stack">' +
                            '       <div class="d-flex flex-stack flex-row-fluid d-grid gap-2">' +
                            '           <div class="me-5">' +
                                            message +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">Last test: <span class="connection_status_datetime">'+row['connection_datetime']+'<span></span>' +
                            '           </div>\n' +
                            '        </div>\n' +
                            '   </div>';
                    }
                },
                {
                    data: 'systems',
                    title: 'Systems',
                    sortable: true,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        for (let i = 0; i < row['systems'].length; i++) {
                            let iconUrl = '/media/goodaccess/icons/system/'+row['systems'][i]['iconID']+'.svg';
                            let serviceHtml = '';
                            if(row['systems'][i]['isAdvanced']){
                                serviceHtml = new ServiceTooltip().getHtml(row['systems'][i]['services']);
                            }
                            if (i < 3) {
                                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300"' + (row['systems'][i]['edit'] ? ' id="'+row['systems'][i]['uuid']+'"' : '') + '>' +
                                    (row['systems'][i]['edit'] ? '<div class="edit-system">' : '') +
                                    '        <div class="symbol-label bg-light-primary border border-2 border-white'+(!row['systems'][i]['isValid'] || row['systems'][i]['isIsolated'] ? ' filter-grayscale' : '')+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center fw-bold\'>'+row['systems'][i]['name']+(row['systems'][i]['customUri'] ? '' : '<i class=\'fa-solid fa-eye-slash ga-text-primary-700 ms-2\'></i>')+'</div><div class=\'text-center\'>'+(row['systems'][i]['customUri'] ? row['systems'][i]['customUri'] : row['systems'][i]['host'])+'</div>'+(row['systems'][i]['isAdvanced'] ? '<div class=\'text-center\'>'+row['systems'][i]['services'].length+' services</div>' : '')+'">'+
                                    '             <img alt="avatar" class="h-40px" src="' + iconUrl + '"/>' +
                                    '        </div>' +
                                    (row['systems'][i]['edit'] ? '</div>' : '') +
                                    (serviceHtml !== '' ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+serviceHtml+'">'+row['systems'][i]['services'].length+'</span>' : '')+
                                    (!row['systems'][i]['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                                    (row['systems'][i]['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                                    '     </div>';
                            } else {
                                html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['systems'].length - 3)+' more systems</div>">' +
                                    '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder">+'+(row['systems'].length - 3)+'</div>'+
                                    '     </div>';
                                break;
                            }
                        }
                        return html+'</div>';
                    }
                },
                {
                    title: 'Actions',
                    sortable: true,
                    render: function (data, type, row) {
                        let html = '<div class="d-flex" id="'+row['id']+'">';
                        let isEnabled = 'checked';
                        let enabledText = 'Enabled';
                        if(!row['is_enabled']){
                            isEnabled = '';
                            enabledText = 'Disabled';

                        }
                        if (row['allowed_to_edit']) {
                            html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-branch" data-cy="edit-cb"  data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                '     <span class="svg-icon svg-icon-3">' +
                                '          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '             <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                                '             <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                                '         </svg>' +
                                '     </span>' +
                                '</div>';
                            html += '<div class="btn btn-icon btn-bg-light btn-sm me-5 delete-branch" data-cy="delete-cb" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete" '+(row['custom_zone_forwarding'] ? 'data-custom-zone-forwarding="'+row['custom_zone_forwarding']+'"' : '')+'>'+
                                '     <span class="svg-icon svg-icon-3">' +
                                '           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '               <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '          </svg>' +
                                '      </span>' +
                                '</div>';
                            html += '    <label class="form-check form-switch form-check-custom form-check-solid cursor-pointer">\n' +
                                '        <input class="form-check-input enable-branch-switch cursor-pointer" type="checkbox" value="1" '+isEnabled+'/>\n' +
                                '        <span class="form-check-label fw-semibold text-muted">\n' +
                                '       <div class="spinner-border spinner-border-sm d-none" role="status">\n' +
                                '               <span class="visually-hidden">Loading...</span>' +
                                '           </div><span class="enabled-text">'+ enabledText +'</span>'+
                                '        </span>' +
                                '    </label>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#branch-datatable_wrapper').hide();
                $('[data-kt-docs-table-toolbar=base]').addClass('d-none');
                $('#branch-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        }).on('draw', function () {
            thisClass.resetSubtable(el);
            thisClass.handleExpandButtons(el);
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    handleExpandButtons(el){
        const thisClass = this;
        const buttons = document.querySelectorAll('[data-kt-docs-datatable-subtable="expand_row"]');

        buttons.forEach((button, index) => {
            button.addEventListener('click', e => {
                e.stopImmediatePropagation();
                e.preventDefault();

                const row = button.closest('tr');
                const rowClasses = ['isOpen', 'border-bottom-0'];

                const rowSubData = [];
                let data = thisClass.datatable.row(row).data().branch_segments;
                for (let j = 0; j < data.length; j++) {
                    rowSubData.push(data[j]);
                }

                // Handle subtable expanded state
                if (row.classList.contains('isOpen')) {
                    // Remove all subtables from current order row
                    while (row.nextSibling && (row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_template' || row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_header_template')) {
                        row.nextSibling.parentNode.removeChild(row.nextSibling);
                    }
                    row.classList.remove(...rowClasses);
                    button.classList.remove('active');
                } else {
                    thisClass.showSubrowsData(rowSubData, row, el);
                    row.classList.add(...rowClasses);
                    button.classList.add('active');
                }

                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
            });
        });
    }
    showSubrowsData(data, target, el){
        let thisClass = this;
        data.forEach((d, index) => {
            // Clone template node
            const newTemplate = thisClass.subtableTemplate.cloneNode(true);
            newTemplate.classList.remove('d-none');

            // Select data elements
            const name = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_name"]');
            const subnetRange = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_subnet_range"]');

            // Populate elements with data
            name.innerText = d.name;
            subnetRange.innerText = d.subnet_range;

            // New template border controller
            if (data.length === 1) {
                if (index === 0) { // last row
                    let borderClasses = ['rounded-start', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[0].classList.add(...borderClasses);
                    borderClasses = ['rounded-end', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[1].classList.add(...borderClasses);
                }
            }

            // Insert new template into table
            const tbody = document.querySelector(el).querySelector('tbody');
            tbody.insertBefore(newTemplate, target.nextSibling);
        });

        const newHeaderTemplate = thisClass.subtableHeaderTemplate.cloneNode(true);
        newHeaderTemplate.classList.remove('d-none');
        // Insert new template into table
        const tbody = document.querySelector(el).querySelector('tbody');
        tbody.insertBefore(newHeaderTemplate, target.nextSibling);
    }
    resetSubtable(el){
        const subtables = document.querySelectorAll('[data-kt-docs-datatable-subtable="subtable_template"]');
        subtables.forEach(st => {
            st.parentNode.removeChild(st);
        });

        const rows = document.querySelector(el).querySelectorAll('tbody tr');
        rows.forEach(r => {
            r.classList.remove('isOpen');
            if (r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]')) {
                r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]').classList.remove('active');
            }
        });
    }
    initActions(organizationID) {
        const thisClass = this;
        $(document).on('change', '.enable-branch-switch', function(e) {
            const statusConnection          = $(this).parent().parent().parent().parent().parent().parent().find('.connection_status')[0];
            const statusConnectionDatetime  = $(this).parent().parent().parent().parent().parent().parent().find('.connection_status_datetime')[0];
            const thisElement = this;
            let newText = 'Enabled';
            if($(this).parent().find('.enabled-text').text() == 'Enabled'){
                newText = 'Disabled';
            }
            const newTextConst = newText;
            let branchID = $(this).parent().parent()[0].id;
            $(this).prop('disabled', true);
            $(this).parent().find('.spinner-border').removeClass('d-none');
            $.ajax({
                url:  '/branches/?do=changeBranchStatus',
                type: 'POST',
                dataType: '',
                data: {is_enable:  e.target.checked ? 1 : 0, branchID:  branchID}
            }).done(function(data) {
                let status = 'disabled';
                if(data['is_enabled']) {
                    status = 'enabled';
                }

                let changeStatus = function (is_connected) {
                    if($(statusConnection).hasClass('m--font-success') && !is_connected) {
                        $(statusConnection).removeClass('m--font-success');
                        $(statusConnection).addClass('m--font-danger');
                    }else if($(statusConnection).hasClass('m--font-danger') && is_connected){
                        $(statusConnection).addClass('m--font-success');
                        $(statusConnection).removeClass('m--font-danger');
                    }
                    $(statusConnection).text(is_connected ? 'Connected' : 'Not Connected');
                };
                changeStatus(data['is_connected']);
                $(statusConnectionDatetime).text(data['is_connected_datetime']);

                $(thisElement).parent().find('.enabled-text').text(newTextConst);
                $(thisElement).parent().find('.spinner-border').addClass('d-none');
                $(thisElement).prop('disabled', false);
                if(data['status'] === 'success'){
                    toastr.success(data['message']);
                }else if(data['status'] === 'warning'){
                    toastr.warning(data['message']);
                }
            });
        });

        $(document).on('click', '#branch-datatable .delete-branch', function(e) {
            const branchID = $(this).parent()[0].id;
            let branchName = $(this).closest('tr').find('span[data-branch-name]').attr('data-branch-name');
            let branchCustomZoneForwarding = $(this).attr('data-custom-zone-forwarding');
            let branch = new Branch(branchID);
            branch.remove(branchName, branchCustomZoneForwarding);
        });
        const thisDatatable = this.datatable;
        this.datatable.on( 'draw', function () {
            if(thisDatatable.page.info().recordsTotal === 0){
                $('#branch-datatable_wrapper').hide();
                $('[data-kt-docs-table-toolbar=base]').addClass('d-none');
                $('#branch-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
    }
}
window.BranchesDatatable = BranchesDatatable;